import { render, staticRenderFns } from "./HubCategories.vue?vue&type=template&id=96cae306&"
import script from "./HubCategories.vue?vue&type=script&lang=js&"
export * from "./HubCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports